import React from "react";
import styled from "styled-components";
import { Box, Text, themeGet } from "@fuegokit/react";

const STATUS_TEXT_COLORS = {
  experimental: "text.subtle",
  alpha: "text.discovery",
  beta: "text.accent.blue.bolder",
  stable: "text.success",
  deprecated: "text.warning.inverse",
  removed: "text.danger",
};

const STATUS_BACKGROUND_COLORS = {
  experimental: "background.neutral.default",
  alpha: "background.discovery.default",
  beta: "background.information.default",
  stable: "background.success.default",
  deprecated: "background.warning.bold.default",
  removed: "background.danger.default",
};

const STATUS_BORDER_COLORS = {
  experimental: "border.subtle",
  alpha: "border.discovery",
  beta: "border.information",
  stable: "border.success",
  deprecated: "border.warning",
  removed: "border.danger",
};

const getStatusTextColor = (status) => {
  return (
    STATUS_TEXT_COLORS[status.toLowerCase()] ||
    "background.subtle.neutral.default"
  );
};

const getStatusBackgroundColor = (status) => {
  return STATUS_BACKGROUND_COLORS[status.toLowerCase()] || "text.subtlest";
};

const getStatusBorderColor = (status) => {
  return STATUS_BORDER_COLORS[status.toLowerCase()] || "border.subtle";
};

const StatusLabel = ({ status }) => {
  return (
    <>
      <BaseStatusLabel
        sx={{
          color: getStatusTextColor(status),
          backgroundColor: getStatusBackgroundColor(status),
          border: "1px solid",
          borderColor: getStatusBorderColor(status),
        }}
      >
        {status}
      </BaseStatusLabel>
    </>
  );
};

const BaseStatusLabel = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  max-height: 24px;
  width: fit-content;
  border-radius: ${themeGet("radii.2")};
  font-size: ${themeGet("fontSizes.1")};
  padding-left: ${themeGet("space.1")};
  padding-right: ${themeGet("space.1")};
  line-height: ${themeGet("lineHeights.default")};
  text-transform: uppercase;
  letter-spacing: -0.01em;
  font-size: 1;
  font-weight: bold;
`;

export default StatusLabel;
